import styles from '../styles/Footer.module.css';

interface FooterProps {
  // The page has affiliate links, which need a disclosure
  affiliateLinks?: boolean;
}

const Footer = ({ affiliateLinks }: FooterProps) => {
  if (!affiliateLinks) return null;
  return (
    <footer className={styles.footer}>
      As an Amazon Associate I earn from qualifying purchases. Links marked (affiliate link) are affiliate links: if you
      buy through them, I may earn a commission at no extra cost to you.
    </footer>
  );
};

export default Footer;
